import { COLORS, formatNumber } from "../utils";

/**
 * 가로 막대 순위 (채널·기기·인앱 등). 항목 이름이 옆에 있으므로 한 가지 색만 쓴다.
 * rows: [{ key, label, value, sub? }]
 */
export function FgRankBars({ rows, total, emptyText = '데이터 없음' }) {
    if (!rows.length) {
        return <p className="py-4 text-xs text-gray-400">{emptyText}</p>;
    }

    const max = Math.max(...rows.map(r => r.value), 1);

    return (
        <ul className="flex flex-col gap-2.5">
            {rows.map(row => {
                const share = total ? row.value / total : 0;
                return (
                    <li key={row.key ?? '__null'} className="flex flex-col gap-1">
                        <div className="flex items-baseline justify-between gap-3 text-[13px]">
                            <span className="min-w-0 truncate text-gray-800" title={row.label}>{row.label}</span>
                            <span className="shrink-0 text-gray-500">
                                <b className="font-semibold text-gray-900">{formatNumber(row.value)}</b>
                                <span className="ml-1.5 inline-block w-10 text-right">{Math.round(share * 100)}%</span>
                            </span>
                        </div>
                        <div className="h-1.5 rounded-full bg-gray-100">
                            <div className="h-full rounded-full" style={{ width: `${Math.max((row.value / max) * 100, 2)}%`, background: COLORS.bar }} />
                        </div>
                        {row.sub && <p className="text-[11px] text-gray-400">{row.sub}</p>}
                    </li>
                );
            })}
        </ul>
    );
}
